if (!customElements.get('ease-sticky-atc-bar')) {
  customElements.define(
    'ease-sticky-atc-bar',
    class EaseStickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('ease-sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      get quantity() {
        return this.querySelector('quantity-input');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get select() {
        return this.querySelector('select[name="id"]');
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      easeScrollToTarget(targetId) {
        if (!targetId) return;
        const anchorEl =
          document.getElementById(targetId) ||
          document.querySelector(`[id^="${targetId}"]`) ||
          document.querySelector('#ease-product-info-target') ||
          document.querySelector('product-info[data-section="main"]') ||
          document.querySelector('product-info[id^="MainProduct-"]');
        if (!anchorEl) return;

        const productInfo = anchorEl.closest?.('product-info') || anchorEl;
        const mediaTopEl =
          productInfo?.querySelector?.('media-gallery') ||
          productInfo?.querySelector?.('.product__media-wrapper') ||
          anchorEl;

        const prefersReduced =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) {
          mediaTopEl.scrollIntoView({ block: 'start' });
          return;
        }

        const start = window.pageYOffset || document.documentElement.scrollTop || 0;
        const rect = mediaTopEl.getBoundingClientRect();
        const target = Math.max(0, start + rect.top - 100);
        const distance = target - start;
        if (Math.abs(distance) < 2) return;

        const duration = Math.min(1200, Math.max(700, Math.abs(distance) * 0.6));

        function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        const t0 = performance.now();
        function step(now) {
          const p = Math.min(1, (now - t0) / duration);
          const y = start + distance * easeInOutCubic(p);
          window.scrollTo(0, y);
          if (p < 1) window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }

      getStickyButtonLabel() {
        const addButton = this.productForm?.querySelector('[name="add"]');
        const raw = addButton?.dataset?.easeStickyAtcLabel;
        return raw && String(raw).trim() ? String(raw).trim() : FoxTheme.variantStrings.addToCart;
      }

      connectedCallback() {
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.ease-sticky-atc-bar');
        /* Haupt-ATC: nur der Button in den Produktinfos, nicht der Sticky-Formular-Button */
        this.mainAtcButton = document.querySelector('.main-product-form button[name="add"]');
        this.scrollButton = this.querySelector('[data-ease-scroll-target]');

        this.variantData = this.getVariantData();
        const vid = this.querySelector(this.selectors.variantIdSelect)?.value;
        if (vid) {
          this.currentVariant = this.variantData.find((v) => v.id === Number(vid));
        }

        this.init();

        if (this.scrollButton) {
          this.scrollButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.easeScrollToTarget(this.scrollButton.getAttribute('data-ease-scroll-target'));
          });
        }

        this.select?.addEventListener('change', () => {
          this.updateQuantityInput();
          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];

              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            this.mainVariantSelects.dispatchEvent(new Event('change'));
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(this.selectors.variantIdSelect)?.value;
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
        const qtyHost = document.querySelector(`#QuantitySticky-${this.sectionId}`);
        if (!qtyHost || !this.currentVariant) return;

        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (quantity && newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        const heroCta = document.querySelector(
          '.ease-salespage-hero-hook-section .ease-sp-hero-hook__cta[data-ease-scroll-target]'
        );
        const productInfoEl =
          document.querySelector('product-info[data-section="main"]') ||
          document.querySelector('product-info[id^="MainProduct-"]');

        if (!heroCta && !productInfoEl) {
          this.container.classList.add('ease-sticky-atc-bar--show');
          this.syncWithMainProductForm();
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        this.heroCtaInView = !!heroCta;
        this.productInfoInView = false;
        this.hasPassedHeroCta = false;

        const updateStickyVisibility = () => {
          const shouldShow = this.hasPassedHeroCta && !this.heroCtaInView && !this.productInfoInView;
          this.container.classList.toggle('ease-sticky-atc-bar--show', shouldShow);
        };

        if (heroCta) {
          this.heroObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.heroCtaInView = entry.isIntersecting;
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                  this.hasPassedHeroCta = true;
                }
                if (entry.isIntersecting) {
                  this.hasPassedHeroCta = false;
                }
              });
              updateStickyVisibility();
            },
            { threshold: 0, rootMargin: '0px 0px 0px 0px' }
          );
          this.heroObserver.observe(heroCta);
        } else {
          this.heroCtaInView = false;
          this.hasPassedHeroCta = true;
        }

        if (productInfoEl) {
          this.productObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.productInfoInView = entry.isIntersecting;
              });
              updateStickyVisibility();
            },
            { threshold: 0.12, rootMargin: '-10% 0px -10% 0px' }
          );
          this.productObserver.observe(productInfoEl);
        }

        updateStickyVisibility();

        this.syncWithMainProductForm();
      }

      checkDevice() {
        document.documentElement.style.setProperty('--ease-sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.productForm;
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        const stickyLabel = this.getStickyButtonLabel();
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = stickyLabel;
        }
      }

      updatePrice() {
        const root = this.querySelector('.ease-sticky-atc-bar__price');
        if (!root || !this.currentVariant) return;

        const priceWrapper = root.querySelector('.price');
        if (!priceWrapper) return;

        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { compare_at_price, price, available } = this.currentVariant;
        const onSale = !!(compare_at_price && compare_at_price > price);

        priceWrapper.classList.toggle('price--on-sale', onSale);
        priceWrapper.classList.toggle('price--sold-out', !available);

        const regularEl = root.querySelector('.price__regular .price-item--regular');
        const saleValueEl = root.querySelector('.ease-sticky-atc-price__sale-value');
        const compareEl = root.querySelector('.price__sale s.price-item--regular');

        if (regularEl) {
          regularEl.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);
        }
        if (saleValueEl) {
          saleValueEl.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);
        }
        if (compareEl) {
          compareEl.innerHTML = onSale
            ? FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)
            : FoxTheme.Currency.formatMoney(price, moneyFormat);
        }
      }

      syncWithMainProductForm() {
        if (!this.mainProductInfo) return;

        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          if (variantInput) variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
        });
      }
    }
  );
}
